module.exports = __webpack_public_path__ + "static/media/terrorist.91410f1f.mp3";